/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { PropsWithChildren } from 'react';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  row: css`
    display: grid;
    grid-template-columns: 240px minmax(0, 1fr);
    gap: var(--cds-spacing-200);
    align-items: start;
    padding: var(--cds-spacing-150) 0;

    @media (max-width: 599px) {
      grid-template-columns: 1fr;
      gap: var(--cds-spacing-100);
    }
  `,
};

export type SettingRowProps = PropsWithChildren<{
  /** The field label, shown in the left column. */
  label: string;
}>;

const SettingRow = ({ label, children }: SettingRowProps) => (
  <div css={styles.row}>
    <Typography2 component="p" variant="subtitleMedium">
      {label}
    </Typography2>
    <div>{children}</div>
  </div>
);

export default SettingRow;
